.snackBar {
  pointer-events: auto;
  width: 296px;
  border-radius: var(--t-border-radius-md);
  background-color: var(--t-background-transparent-primary);
  backdrop-filter: var(--t-blur-medium);
  -webkit-backdrop-filter: var(--t-blur-medium);
  box-shadow: var(--t-box-shadow-strong);
  box-sizing: border-box;
  padding: var(--t-spacing-2) var(--t-spacing-2) var(--t-spacing-1);
  position: relative;
}

.default {
  --snack-bar-icon-color: var(--foreground-secondary);
  --snack-bar-progress-color: color-mix(
    in oklab,
    var(--foreground) 15%,
    transparent
  );
}

.success {
  --snack-bar-icon-color: var(--success);
  --snack-bar-progress-color: color-mix(
    in oklab,
    var(--success) 15%,
    transparent
  );
}

.error {
  --snack-bar-icon-color: var(--destructive);
  --snack-bar-progress-color: color-mix(
    in oklab,
    var(--destructive) 15%,
    transparent
  );
}

.info {
  --snack-bar-icon-color: var(--info);
  --snack-bar-progress-color: color-mix(in oklab, var(--info) 15%, transparent);
}

.warning {
  --snack-bar-icon-color: var(--warning);
  --snack-bar-progress-color: color-mix(
    in oklab,
    var(--warning) 15%,
    transparent
  );
}

.header {
  align-items: center;
  color: var(--t-font-color-primary);
  display: flex;
  font-weight: var(--t-font-weight-medium);
  gap: var(--t-spacing-2);
  margin-bottom: var(--t-spacing-1);
}

.icon {
  color: var(--snack-bar-icon-color, var(--foreground-secondary));
  display: flex;
  align-items: center;
  justify-content: center;
}

.message {
  margin: 0;
  color: var(--t-font-color-secondary);
  font-size: var(--t-font-size-sm);
}

.details {
  margin: 0;
  color: var(--t-font-color-tertiary);
  font-size: var(--t-font-size-sm);
  overflow: hidden;
  padding-left: var(--t-spacing-6);
  text-overflow: ellipsis;
  width: 200px;
}

.actions {
  align-items: center;
  display: flex;
  margin-left: auto;
}

.action {
  padding-left: 0;
}

.actionLink {
  color: var(--t-font-color-tertiary);
  font-size: var(--t-font-size-sm);
}

.actionLink:hover {
  color: var(--t-font-color-secondary);
}

.dismiss {
  width: 24px;
  height: 24px;
  color: var(--muted-foreground);
  opacity: 1;
  margin-top: 0;
  transition:
    opacity var(--motion-fast) linear,
    background-color var(--motion-fast) linear;
  border-radius: var(--radius-sm);
}

.bottomActionContainer {
  margin-top: var(--t-spacing-2);
}

.separator {
  border: 0;
  border-top: 1px solid var(--t-border-color-light);
  margin: 0;
}

.bottomAction {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding-top: var(--t-spacing-1);
}

@media (max-width: 768px) {
  .snackBar {
    border-radius: 0;
    width: 100%;
  }
}
